import { render, staticRenderFns } from "./Rotaion.vue?vue&type=template&id=4c308af1&scoped=true&lang=pug&"
import script from "./Rotaion.ts?vue&type=script&lang=ts&"
export * from "./Rotaion.ts?vue&type=script&lang=ts&"
import style0 from "./Rotaion.vue?vue&type=style&index=0&id=4c308af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c308af1",
  null
  
)

export default component.exports